import createVueComponent from '../createVueComponent';

const FishSymbol = createVueComponent('FishSymbolIcon', [
  ['path', { d: 'M2 16s9-15 20-4C11 23 2 8 2 8', key: 'h4oh4o' }],
]);

export default FishSymbol;
